/** 玩法 Tab（對齊 PlayType 枚舉） */
export const PLAY_TYPE_TABS = [
  { key: 'TIME_LIMITED', label: '限時投注' },
  { key: 'FUTURES', label: '交割合約' },
  { key: 'PERPETUAL', label: '永續合約' },
];

export function isPlayTypeTabDisabled() {
  // 控獎配置允許在尚無商品時先行設定，Tab 不因數量為 0 禁用。
  return false;
}

export function getDefaultPlayType(tabCounts) {
  const firstWithProducts = PLAY_TYPE_TABS.find(
    (tab) => (tabCounts?.[tab.key] ?? 0) > 0
  );
  return firstWithProducts?.key || 'TIME_LIMITED';
}

export const PLAY_TYPE_LABELS = {
  TIME_LIMITED: '限時投注',
  FUTURES: '交割合約',
  PERPETUAL: '永續合約',
};

export const ENABLED_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'true', label: '啟用' },
  { value: 'false', label: '禁用' },
];

/** 限時控獎方向 */
export const TIMED_DIRECTION_OPTIONS = [
  { value: 'LOSE', label: '輸' },
  { value: 'WIN', label: '贏' },
];

/** 永續單控方向（controlWin） */
export const PERPETUAL_PERSONAL_DIRECTION_OPTIONS = [
  { value: 'true', label: '玩家有利' },
  { value: 'false', label: '平台有利' },
];

/** 永續全局方向（direction） */
export const PERPETUAL_GLOBAL_DIRECTION_OPTIONS = [
  { value: 'WIN', label: '玩家有利' },
  { value: 'LOSE', label: '平台有利' },
];

/** 交割單控方向（controlWin） */
export const FUTURES_PERSONAL_DIRECTION_OPTIONS = [
  { value: 'true', label: '贏' },
  { value: 'false', label: '輸' },
];

/** 交割全局賠率配置 */
export const FUTURES_ODDS_METHOD_OPTIONS = [
  { value: 'false', label: '隨機賠率' },
  { value: 'true', label: '真實賠率' },
];

export const FUTURES_GLOBAL_LINK = {
  label: '交割週期配置',
  path: '/system/fast-contract-manage/fast-contract-cycle-record',
  hint: '局級場控、秒合約配置請至「交割合約 → 週期記錄」操作。',
};

export const FUTURES_PERSONAL_HINT =
  '說明：若同局單控方向衝突（同時存在控漲與控跌），則整局單控無效，改依局開獎結果。';

export const FUTURES_GLOBAL_HINT =
  '交割合約賠率判斷順序：用戶層級 > 個人賠率 > 全局賠率。';

export function directionLabel(playType, record) {
  if (playType === 'FUTURES') {
    if (record?.controlWin === true) {
      return '贏';
    }
    if (record?.controlWin === false) {
      return '輸';
    }
    return '—';
  }
  if (playType === 'PERPETUAL') {
    if (record?.controlWin === true) {
      return '玩家有利';
    }
    if (record?.controlWin === false) {
      return '平台有利';
    }
    const dir = record?.direction;
    if (dir === 'WIN') {
      return '玩家有利';
    }
    if (dir === 'LOSE') {
      return '平台有利';
    }
    return '—';
  }
  const dir = record?.direction;
  if (dir === 'WIN') {
    return '贏';
  }
  if (dir === 'LOSE') {
    return '輸';
  }
  return dir || '—';
}

export function directionTone(playType, record) {
  const label = directionLabel(playType, record);
  if (label === '贏' || label === '玩家有利') {
    return 'win';
  }
  if (label === '輸' || label === '平台有利') {
    return 'lose';
  }
  return 'neutral';
}

export function enabledLabel(enabled) {
  return enabled ? '啟用' : '禁用';
}

export function enabledTone(enabled) {
  return enabled ? 'enabled' : 'disabled';
}

export function formatPercentValue(value) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  const display = num <= 10 ? num * 100 : num;
  return `${display}%`;
}

export function formatNumberValue(value) {
  if (value == null || value === '') {
    return '—';
  }
  return String(value);
}
